import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MtRolesRouting } from '../../models/mt-roles-routing';
import { ModulTozsamosciAccessCheckerService } from '../../services/modul-tozsamosci-access-checker/modul-tozsamosci-access-checker.service';
import { ModulTozsamosciService } from '../../services/modul-tozsamosci-service/modul-tozsamosci.service';

@Injectable({
  providedIn: 'root'
})
export class ModulTozsamosciGuard implements CanActivate {

  constructor(
    private mtService: ModulTozsamosciService,
    private mtChecker: ModulTozsamosciAccessCheckerService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (route.data.roles !== undefined && route.data.roles !== null) {
        const routeParams: MtRolesRouting = route.data.roles.mt as MtRolesRouting;
        return this.mtChecker.isAccessGranted(routeParams);
      } else {
        return this.mtService.isAuthenticated();
      }
  }
}
